import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNeutral = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599976 23 0.599976C10.6288 0.599976 0.599976 10.6288 0.599976 23C0.599976 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint0_radial_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599976 23 0.599976C10.6288 0.599976 0.599976 10.6288 0.599976 23C0.599976 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint1_radial_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.954 13.2002C19.094 12.1362 18.212 11.3382 16.56 11.1282C15.146 10.9462 11.94 11.4782 9.39203 14.4882C8.91603 15.0482 9.47603 15.4542 9.92403 15.1182C11.408 13.9562 15.132 12.6962 17.82 13.4102C18.898 13.6762 18.954 13.2002 18.954 13.2002Z",
			fill: "url(#paint2_linear_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6916 23.9519C16.8824 23.9519 17.8476 22.4914 17.8476 20.6899C17.8476 18.8883 16.8824 17.4279 15.6916 17.4279C14.5009 17.4279 13.5356 18.8883 13.5356 20.6899C13.5356 22.4914 14.5009 23.9519 15.6916 23.9519Z",
			fill: "url(#paint3_radial_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6916 18.5339C16.6156 18.5339 17.4276 19.3458 17.8476 20.5358C17.8196 18.7718 16.8676 17.3578 15.6916 17.3578C14.5156 17.3578 13.5636 18.7718 13.5356 20.5358C13.9556 19.3458 14.7536 18.5339 15.6916 18.5339Z",
			fill: "url(#paint4_linear_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3081 23.9519C31.4988 23.9519 32.4641 22.4914 32.4641 20.6899C32.4641 18.8883 31.4988 17.4279 30.3081 17.4279C29.1174 17.4279 28.1521 18.8883 28.1521 20.6899C28.1521 22.4914 29.1174 23.9519 30.3081 23.9519Z",
			fill: "url(#paint5_radial_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3081 18.6182C29.3841 18.6182 28.5721 19.4302 28.1521 20.6202C28.1801 18.8562 29.1321 17.4422 30.3081 17.4422C31.4841 17.4422 32.4361 18.8562 32.4641 20.6202C32.0441 19.4302 31.2461 18.6182 30.3081 18.6182Z",
			fill: "url(#paint6_linear_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.046 13.2002C26.906 12.1362 27.788 11.3382 29.44 11.1282C30.854 10.9462 34.06 11.4782 36.608 14.4882C37.084 15.0482 36.524 15.4542 36.076 15.1182C34.592 13.9562 30.868 12.6962 28.18 13.4102C27.102 13.6762 27.046 13.2002 27.046 13.2002Z",
			fill: "url(#paint7_linear_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.4363 32.7722H13.5643C12.9903 32.7722 12.5143 32.2962 12.5143 31.7222C12.5143 31.1482 12.9903 30.6722 13.5643 30.6722H32.4363C33.0103 30.6722 33.4863 31.1482 33.4863 31.7222C33.4863 32.2962 33.0103 32.7722 32.4363 32.7722Z",
			fill: "url(#paint8_radial_5_4691)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4663 31.2322H32.5483C32.9543 31.2322 33.3183 31.4702 33.4863 31.8062C33.4863 31.7782 33.4863 31.7502 33.4863 31.7222C33.4863 31.1482 33.0103 30.6722 32.4363 30.6722H13.5643C12.9903 30.6722 12.5143 31.1482 12.5143 31.7222C12.5143 31.7502 12.5143 31.7782 12.5143 31.8062C12.6963 31.4562 13.0463 31.2322 13.4663 31.2322Z",
			fill: "url(#paint9_linear_5_4691)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_5_4691",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5927 13.922) scale(27.0227)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE030" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFB92E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_5_4691",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5927 13.922) scale(21.26)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFEA5F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBC47",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5_4691",
				x1: 14.0428,
				y1: 14.3866,
				x2: 14.4058,
				y2: 11.5782,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7A4400"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_5_4691",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.032 20.7759) rotate(73.8539) scale(3.16496 2.04768)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5_4691",
				x1: 15.6863,
				y1: 17.4152,
				x2: 15.6863,
				y2: 20.4552,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_5_4691",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(29.6598 20.7764) rotate(73.8539) scale(3.16496 2.04768)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_5_4691",
				x1: 30.3135,
				y1: 17.4956,
				x2: 30.3135,
				y2: 20.5356,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_5_4691",
				x1: 31.9579,
				y1: 14.3873,
				x2: 31.5948,
				y2: 11.579,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7A4400"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint8_radial_5_4691",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(23.0003 31.7163) scale(7.45182 1.34058)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint9_linear_5_4691",
				x1: 12.5143,
				y1: 31.2314,
				x2: 33.4863,
				y2: 31.2314,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			})
		] })
	]
});
export { SvgNeutral as ReactComponent };
